import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
} from "reactstrap"
import { get, put, post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useParams, useNavigate } from "react-router-dom"
import {
  EMERGENCY_TYPES_SEARCH,
  UPDATE_EMERGENCY_SUB_TYPES,
  LANGUAGES_SEARCH,
  SHOW_EMERGENCY_SUB_TYPES,
} from "helpers/api_endpoints"
import Select from "react-select"
import { Trans } from "react-i18next"
import { useTranslation } from "react-i18next"

document.title = "Edit Emergency Sub Type"

function EditEmergencySubType() {
  const { i18n } = useTranslation()
  const [loading, setLoading] = useState(true)
  const params = useParams()
  const [id, setid] = useState("")
  const [title, setTitle] = useState("")
  const [valued, setValued] = useState({ title: [] })
  const [languages, setLanguages] = useState([])
  const [errorMsg, seterrorMsg] = useState("")
  const navigate = useNavigate()
  const [emergencyType, setEmergencyType] = useState([])
  const [emergencyTypeId, setEmergencyTypeId] = useState([])

  useEffect(() => {
    const getEmergencyTypes = async () => {
      setLoading(true)
      try {
        const response = await post(`${EMERGENCY_TYPES_SEARCH}`).then(res => {
          setEmergencyType(res.data)
        })
        setLoading(false)
      } catch (error) {
        console.log(error)
      }
    }
    const getEmergencySubType = async () => {
      setLoading(true)
      try {
        const response = await get(`${SHOW_EMERGENCY_SUB_TYPES}/${params.id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Accept-Language":""
            },
          }
        )
        const emergencySubType = response.data
        
        const parsedTitle =
          typeof emergencySubType.title === "string"
            ? JSON.parse(emergencySubType.title)
            : emergencySubType.title

        setid(emergencySubType.id)
        setValued({
          ...emergencySubType,
          title: parsedTitle.title,
        })

        if (emergencySubType.emergencyTypeId) {
          setEmergencyTypeId(emergencySubType.emergencyTypeId)
        }
        setLoading(false)
      } catch (error) {
        console.log(error)
        seterrorMsg(error.message)
      }
    }
    const getLanguages = async () => {
      setLoading(true)
      try {
        const response = await post(`${LANGUAGES_SEARCH}`, { status: 1 })
        const languages = response.data
        setLanguages(languages)
        setLoading(false)
      } catch (error) {
        console.log(error)
        seterrorMsg(error.message)
      }
    }
    getLanguages()
    getEmergencyTypes()
    getEmergencySubType()
  }, [params.id])

  const handleSubmit = e => {
    e.preventDefault()

    const payload = {
      id,
      title: JSON.stringify({
        title: valued.title,
      }),
      emergencyTypeId: parseInt(emergencyTypeId, 10),
    }

    put(UPDATE_EMERGENCY_SUB_TYPES, payload)
      .then(response => {
        if (response.code === 200) {
          navigate("/emergency-sub-types", {
            state: { successMsg: "Emergency Sub Type Updated Successfully" },
          })
        }
      })
      .catch(error => {
        console.error("Update error:", error)
        seterrorMsg(error.message || "Failed to update emergency sub-type")
      })
  }

  const handleTitle = (languageId, value) => {
    const currentTitles = Array.isArray(valued.title) ? [...valued.title] : []

    const existingIndex = currentTitles.findIndex(
      el => el[languageId] !== undefined
    )

    if (existingIndex === -1) {
      const newEntry = { [languageId]: value }
      currentTitles.push(newEntry)
    } else {
      currentTitles[existingIndex][languageId] = value
    }

    setValued({ ...valued, title: currentTitles })
    setTitle(JSON.stringify(valued))
  }

  const getTranslatedText = (titleData, defaultText = "") => {
    try {
      if (typeof titleData === "string") {
        try {
          const parsed = JSON.parse(titleData)
          if (Array.isArray(parsed?.title)) {
            const langMap = { en: 1, ar: 2, ur: 3, fa: 4, ps: 5 }
            const langKey = langMap[i18n.language] || 1
            const titleObj = parsed.title.find(item => item && item[langKey])
            return titleObj ? titleObj[langKey] : defaultText
          }
          return parsed.title || defaultText
        } catch (e) {
          return titleData || defaultText
        }
      }

      if (titleData && typeof titleData === "object") {
        return getTranslatedText(titleData.title, defaultText)
      }

      return defaultText
    } catch (error) {
      console.error("Error in getTranslatedText:", error)
      return defaultText
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Emergency Sub Type"
            breadcrumbItem="Edit Emergency Sub Type"
          />
          <Form className="form-horizontal" onSubmit={handleSubmit}>
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {errorMsg ? (
                        <Alert color="danger">{errorMsg}</Alert>
                      ) : null}
                      {languages.map((language, index) => (
                        <Row key={index}>
                          <div className="form-group col-md-4 mt-2">
                            <Label className="form-label">
                              <Trans>Title ({language.name})</Trans>
                            </Label>
                            <Input
                              name="title"
                              value={
                                valued.title && Array.isArray(valued.title)
                                  ? (() => {
                                      const langEntry = valued.title.find(
                                        el => el[language.id] !== undefined
                                      )
                                      return langEntry
                                        ? langEntry[language.id]
                                        : ""
                                    })()
                                  : ""
                              }
                              className="form-control"
                              placeholder="Enter Title"
                              type="text"
                              onChange={e =>
                                handleTitle(language.id, e.target.value)
                              }
                              required={language.id === 1 || language.id === 2}
                            />
                          </div>
                        </Row>
                      ))}
                    </Row>

                    <Row>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Emergency Type</Trans>
                        </Label>
                        <Input
                          name="emergency_type"
                          className="form-control"
                          placeholder="Select Emergency Type"
                          type="select"
                          value={
                            emergencyTypeId ||
                            (valued.emergencyTypeId
                              ? String(valued.emergencyTypeId)
                              : "")
                          }
                          onChange={e =>
                            setEmergencyTypeId(parseInt(e.target.value, 10))
                          }
                          required
                        >
                          <option value="">Select Emergency Type</option>
                          {emergencyType.map((item, index) => (
                            <option key={index} value={item.id}>
                              {getTranslatedText(item.title, "")}
                            </option>
                          ))}
                        </Input>
                      </div>
                    </Row>
                    <div className="text-center  mt-4">
                      <Button type="submit" color="danger">
                        <Trans>Submit</Trans>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditEmergencySubType
